import {
  combineReducers
} from 'redux';

import general from './general'
import ui from './ui';
import config from './config';
import render from './render';
import form from './form';
import user from './user';
import error from './error';


const rootReducer = combineReducers({
    config,
    user,
    ui,
    general,
    render,
    form,
    error,
  }
);

export default rootReducer;
